import styled from 'styled-components';
import { Avatar } from '@mui/material';
import { gray6 } from '../globals/colors';

export var Token = styled(Avatar).withConfig({ displayName: "Tokenstyle__Token", componentId: "sc-hbuhe-0" })(["background:", ";height:3em;width:3em;font-size:inherit;svg{width:1.75em !important;height:1.75em !important;path{fill:white;}}"],
gray6);
//# sourceMappingURL=Token.style.js.map